import { render } from "./Summarize.vue?vue&type=template&id=363feed4"
import script from "./Summarize.vue?vue&type=script&lang=js"
export * from "./Summarize.vue?vue&type=script&lang=js"

import "./Summarize.vue?vue&type=style&index=0&id=363feed4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__